'use client';

import * as S from './styles';
// import { IconeAppleLogin } from '@/components/atoms/Icones/IconeAppleLogin';
// import { IconeFacebookLogin } from '@/components/atoms/Icones/IconeFacebookLogin';
import TextField, { TextFieldSize } from '@/components/molecules/TextField';
import Button, { ButtonColor } from '@/components/atoms/Button';
import IconButton from '@/components/atoms/IconButton';
import { IconeOlho } from '@/components/atoms/Icones/IconeOlho';
import { IconeOlhoFechado } from '@/components/atoms/Icones/IconeOlhoFechado';
import Text from '@/components/atoms/Text';
import { useSearchParams } from 'next/navigation';
import { useRouter } from 'next/navigation';
import { registrarEvento } from '@/services/googleAnalytics';
import useLogarScreenHook from '../../../hook/useLogarScreenHook';
import { CSSProperties, ReactNode } from 'react';
import { Separator } from '@/components/atoms/Separator';
import { theme } from '@/styles/theme';

export interface LogarData {
  email: string;
  senha: string;
}

export type LoginFormProps = {
  corBotaoLogar?: ButtonColor;
  corTextosAcao?: ButtonColor;
  BotaoLoginComGoogle?: ReactNode;
  tamanhosInput?: TextFieldSize;
  style?: CSSProperties;
  formStyle?: CSSProperties;
  onSubmit: (formLogar: LogarData) => Promise<void>;
  styleBotaoEntrar?: CSSProperties;
  carregando: boolean;
  funcaoBotaoCadastrar?: () => void;
  funcaoBotaoEsqueciSenha?: () => void;
};

export default function LoginForm(props: LoginFormProps) {
  const {
    corBotaoLogar = 'accent',
    corTextosAcao = 'accent',
    tamanhosInput = 2,
    BotaoLoginComGoogle = undefined,
    style = {},
    formStyle = {},
    onSubmit,
    styleBotaoEntrar = {},
    carregando,
    funcaoBotaoCadastrar = undefined,
    funcaoBotaoEsqueciSenha = undefined,
  } = props;

  const searchParams = useSearchParams();
  const router = useRouter();

  const {
    errors,
    esconderTexto,
    handleSubmit,
    isValid,
    register,
    setEsconderTexto,
    setFocus,
  } = useLogarScreenHook();

  return (
    <S.Container style={style}>
      <S.FormRoot onSubmit={handleSubmit(onSubmit)} style={formStyle}>
        <TextField
          $size={tamanhosInput}
          $variant="surface"
          $state="placeholder"
          $error={errors.email?.message ?? false}
          $label="E-mail"
          $focusRing={false}
          $placeholder="E-mail"
          $obrigatorio={true}
          $name="email"
          $inputProps={register('email')}
        />
        <TextField
          $size={tamanhosInput}
          $variant="surface"
          $state="placeholder"
          $error={errors.senha?.message ?? false}
          $label="Senha"
          $focusRing={false}
          $placeholder="Senha"
          $obrigatorio={true}
          $name="senha"
          $inputProps={{
            ...register('senha'),
            type: esconderTexto ? 'password' : 'text',
          }}
          $ItemEnd={
            <IconButton
              $size={tamanhosInput}
              $variant="ghost"
              $color="neutral"
              $highContrast={true}
              $loading={false}
              $state="default"
              $focusRing={false}
              $Icon={esconderTexto ? IconeOlhoFechado : IconeOlho}
              $onClick={() => {
                setFocus('senha');
                setEsconderTexto((estadoAnterior) => !estadoAnterior);
              }}
              style={{
                padding: 0,
              }}
            />
          }
        />
        <S.ContainerBotoes>
          <Button
            $size={2}
            $variant="solid"
            $color={corBotaoLogar}
            $highContrast={false}
            $loading={carregando}
            $focusRing={false}
            $text="Entrar"
            $disable={!isValid}
            style={{
              justifyContent: 'center',
              ...(isValid ? styleBotaoEntrar : {}),
            }}
            $type="submit"
          />
          <Button
            $size={1}
            $variant="ghost"
            $color={corTextosAcao}
            $highContrast={['neutral'].includes(corTextosAcao) ? true : false}
            $loading={false}
            $focusRing={false}
            $text="Esqueceu a senha?"
            style={{ justifyContent: 'center' }}
            $type="button"
            $onClick={() => {
              if (funcaoBotaoEsqueciSenha) return funcaoBotaoEsqueciSenha();
              router.replace(`/esqueci-minha-senha?${searchParams.toString()}`);
            }}
          />
        </S.ContainerBotoes>
      </S.FormRoot>
      <Separator
        $block={false}
        $orientation="horizontal"
        style={{
          alignSelf: 'center',
          background: theme.colors.neutral.neutral_alpha[6],
          maxWidth: '50%',
        }}
      />
      <Text
        $size={2}
        $color="neutral"
        $weight="medium"
        $align="center"
        $highContrast={true}
        $text="Ou entre utilizando suas redes sociais"
      />
      <S.BotoesLoginRedeSocialContainer>
        {BotaoLoginComGoogle}
        {/* <Button
          $size={2}
          $variant="soft"
          $color="neutral"
          $highContrast={true}
          $IconStart={IconeFacebookLogin}
          $focusRing={false}
          $text="Facebook"
          style={{
            justifyContent: 'center',
          }}
          $iconStartProps={{
            size: theme.typography.font.size[5],
          }}
          $loading={carregandoLoginFacebook}
          $disable={carregando || carregandoLoginApple || carregandoLoginGoogle}
          $onClick={() => {}}
        />
        <Button
          $size={2}
          $variant="soft"
          $color="neutral"
          $highContrast={true}
          $IconStart={IconeAppleLogin}
          $focusRing={false}
          $text="Apple"
          style={{
            justifyContent: 'center',
          }}
          $iconStartProps={{
            size: theme.typography.font.size[5],
          }}
          $loading={carregandoLoginApple}
          $disable={
            carregando || carregandoLoginFacebook || carregandoLoginGoogle
          }
          $onClick={logarComApple}
        /> */}
      </S.BotoesLoginRedeSocialContainer>
      <S.ContainerIrParaPaginaCadastro>
        <Text
          $size={2}
          $color="neutral"
          $weight="medium"
          $align="center"
          $highContrast={false}
          $text="Não tem cadastro?"
        />
        <Button
          $size={1}
          $variant="ghost"
          $color="accent"
          $highContrast={false}
          $loading={false}
          $focusRing={false}
          $text="Cadastre-se agora"
          $onClick={() => {
            registrarEvento('clicou_cadastro', {});
            if (funcaoBotaoCadastrar) {
              return funcaoBotaoCadastrar();
            }
            return router.replace(`/cadastrar?${searchParams.toString()}`);
          }}
        />
      </S.ContainerIrParaPaginaCadastro>
    </S.Container>
  );
}
